import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${props => props.colors.historyModalBg || props.colors.background || '#1e1e1e'};
  padding: 1.45rem;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 10001;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
`;

const ModalTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.colors.historyModalTexts || props.colors.text || '#ffffff'};
  margin: 0 0 0.97rem 0;
  padding-right: 1.45rem;
  letter-spacing: ${props => `${props.fontSpacing?.letterSpacing.value}${props.fontSpacing?.letterSpacing.unit}`};
  line-height: ${props => `${props.fontSpacing?.lineHeight.value}${props.fontSpacing?.lineHeight.unit}`};
  word-spacing: ${props => `${props.fontSpacing?.wordSpacing.value}${props.fontSpacing?.wordSpacing.unit}`};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.97rem;
  right: 0.97rem;
  background: none;
  border: none;
  color: ${props => props.colors.historyModalTexts || props.colors.text || '#ffffff'};
  cursor: pointer;
  padding: 0.387rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const HistoryItem = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

const ArtworkContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
`;

const Artwork = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const SongInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const SongTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => props.colors.historyModalTexts || props.colors.text || '#ffffff'};
  letter-spacing: ${props => `${props.fontSpacing?.letterSpacing.value}${props.fontSpacing?.letterSpacing.unit}`};
  line-height: ${props => `${props.fontSpacing?.lineHeight.value}${props.fontSpacing?.lineHeight.unit}`};
  word-spacing: ${props => `${props.fontSpacing?.wordSpacing.value}${props.fontSpacing?.wordSpacing.unit}`};
`;

const ArtistName = styled.div`
  font-size: 0.75rem;
  color: ${props => props.colors.historyModalTexts ? `${props.colors.historyModalTexts}99` : props.colors.text ? `${props.colors.text}99` : '#ffffff99'};
  letter-spacing: ${props => `${props.fontSpacing?.letterSpacing.value}${props.fontSpacing?.letterSpacing.unit}`};
  line-height: ${props => `${props.fontSpacing?.lineHeight.value}${props.fontSpacing?.lineHeight.unit}`};
  word-spacing: ${props => `${props.fontSpacing?.wordSpacing.value}${props.fontSpacing?.wordSpacing.unit}`};
`;

const HistoryModal = ({ isOpen, onClose, songHistory, colors, settings, fontSpacing }) => {
  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <Modal colors={colors}>
        <ModalTitle colors={colors} fontSpacing={fontSpacing}>{settings?.historyHeaderText || 'Song History'}</ModalTitle>
        <CloseButton onClick={onClose} colors={colors}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <HistoryList>
          {songHistory?.map((item) => (
            <HistoryItem key={item.sh_id}>
              <ArtworkContainer>
                <Artwork src={item.song.art} alt={item.song.title} />
              </ArtworkContainer>
              <SongInfo>
                <SongTitle colors={colors} fontSpacing={fontSpacing}>{item.song.title}</SongTitle>
                <ArtistName colors={colors} fontSpacing={fontSpacing}>{item.song.artist}</ArtistName>
              </SongInfo>
            </HistoryItem>
          ))}
        </HistoryList>
      </Modal>
    </>
  );
};

export default HistoryModal; 